<template>
  <div>
    <v-card class="mt-4 pt-2 pb-2" flat>
      <v-card-actions>
        <v-select
          outlined
          v-model="SelCompany"
          :items="CompanyName"
          item-text="companytype_name"
          item-value="companytype_id"
          label="Select Company type"
          dense
          :rules="[(v) => !!v || 'Company type is required']"
          required
          return-object
          @change="clearData"
          hide-details
          full-width
        ></v-select>
        <v-btn color="primary" class="ml-3" raised dark large @click="load">
          RELOAD
        </v-btn>
        <v-btn
          color="success"
          class="ml-3"
          raised
          dark
          large
          @click="savechanges"
        >
          SAVE CHANGES
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-row>
      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-text>Choose JOB(s)</v-card-text>

          <v-data-table
            v-model="selected"
            :headers="hdrjobtype"
            :items="arrjobtype"
            item-key="jobtype_id"
            show-select
           
            dense
            :loading="loading"
            :search="search"
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                label="Search"
                hide-details
                class="ml-4 mr-4 mb-5 mt-0 pt-0"
              ></v-text-field>
            </template>

           


            

            <template v-slot:no-data>No Record(s)</template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-text>Selected JOB(s)</v-card-text>
          <v-data-table
            :headers="hdr1jobtype"
            :items="selected"
            item-key="jobtype_id"
            dense
            :loading="loading"
            :search="search1"
          >
            <template v-slot:top>
              <v-text-field
                v-model="search1"
                label="Search"
                single-line
                hide-details
                class="ml-4 mr-4 mb-5 mt-0 pt-0"
              ></v-text-field>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.jobtype_id }}</td>
                <td>{{ item.jobtype_name }}</td>
                <td v-if="(item.local == 'No')">
                <v-icon  color="red">mdi-window-close</v-icon>
              </td>
              <td v-if="(item.local == 'Yes')">
                <v-icon  color="green">mdi-check</v-icon>
              </td>
              <td v-if="(item.central == 'No')">
                <v-icon  color="red">mdi-window-close</v-icon>
              </td>
              <td v-if="(item.central == 'Yes')">
                <v-icon  color="green">mdi-check</v-icon>
              </td>
              </tr>
            </template>
            <template v-slot:no-data>No Record(s)</template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" shaped top :color="snackbarcolor">
      {{ snackbartext }}
      <v-btn color="indigo" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    snackbar: false,
    snackbartext: "",
    snackbarcolor: "primary",
    loading: false,
    checkbox: "",
    chkselected: "",
    selected: [],
    CompanyName: [],
    SelCompany: "",
    search: "",
    search1: "",
    btrue: true,
    inputclass: {
      cid: "",
      jid: [],
    },

    arrjobtype: [],
    hdrjobtype: [
      { text: "ID", value: "jobtype_id" },
      { text: "JOB NAME", value: "jobtype_name" },
      { text: "Local", value: "local" },
      { text: "Central", value: "central" },
    ],

    arr1jobtype: [],
    hdr1jobtype: [
      { text: "ID", value: "jobtype_id" },
      { text: "SELECTED JOB", value: "jobtype_name" },
       { text: "Local", value: "local" },
      { text: "Central", value: "central" },
    ],

    editedItem: {
      jobtype_id: "",
      jobtype_name: 0,
      companytype_id: 0,
      mapping_status: false,
    },
  }),
  mounted() {
    this.bindcompanytype();
    // this.Gridbindjobtype();
    // this.Gridbindjobtype(4);
  },
  watch: {
    selected: function () {
    },
    bindcompanytype: function(){
      
    }

  },
  methods: {
    showSnackbar: function (scolor, stext) {
      this.snackbar = true;
      this.snackbartext = stext;
      this.snackbarcolor = scolor;
    },

    addvalue: function (id, name, cid, status) {
      alert(id + " " + name + " " + cid + " " + status);
      this.editedItem.jobtype_id = id;
      this.editedItem.jobtype_name = name;
      this.editedItem.companytype_id = cid;
      this.editedItem.mapping_status = "true";
      this.arr1jobtype.push(this.editedItem);
      //  this.arr1jobtype.splice()
    },
    clearData: function () {
      this.arrjobtype = [];
      this.selected = [];
    },
    load: function () {
      //alert(this.SelCompany.companytype_id)
      this.selected = [];
      this.loading = true;
      this.Gridbindjobtype(this.SelCompany.companytype_id);
    },
    savechanges: function () {
      if(this.selected.length<=0)
      {
        this.showSnackbar("error", "Select job type before save !");
      return;
      }
      this.inputclass.jid = [];
      this.selected.forEach((el) => {
        this.inputclass.jid.push(el.jobtype_id);
      });
      this.inputclass.cid = this.SelCompany.companytype_id;

      axios
        .post(this.$apiPath + "CompanyType_JobType", this.inputclass, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          if (res.data.status == "Success") {
            this.showSnackbar("Success", "company and  Job merged !");
            this.Reload();
          }
        })
        .catch()
        .finally();
    },

    handleClick(value) {
      alert("dddd");
      console.log(value);
    },
    bindcompanytype: async function () {
      await axios
        .get(this.$apiPath + "Companytype", {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.CompanyName = res.data.result;
        })
        .catch()
        .finally();
    },

    Gridbindjobtype: async function (comid) {
      await axios
        .get(this.$apiPath + "CompanyType_JobType/GetMappingStatus/" + comid, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.arrjobtype = res.data.result;
         // console.log("djdhsjdsdsd");
         // console.log(res.data.result);
           this.selected = this.arrjobtype.filter(
             (task) => task.companytype_id == this.SelCompany.companytype_id
           );
        })
        .catch()
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>